module.exports = "/static/assets/855a0d7847380c26af17d003a964103f.png";